<template>
  <div>
    <div class="breadcrumb-area pos-relative w-100">
      <h1>Thông báo chiến dịch</h1>
      <div class="float-right btn-group" v-show="showImportBtn">
        <!-- <b-link class="font-medium btn btn-outline-secondary" href="/files/template-merchant-assign-nvcs.xlsx" target="_blank">
          <i class="bx bx-download"></i> Tải file mẫu
        </b-link> -->
        <b-button
          variant="outline-secondary"
          :disabled="isDownloadFile"
          @click="downloadTemplateFile"
        >
          <i
            class="bx"
            :class="{
              'bx-loader': isDownloadFile,
              'bx-download': !isDownloadFile,
            }"
          ></i>
          Tải file mẫu
        </b-button>
        <b-button
          variant="outline-secondary"
          :disabled="isUploadFile"
          @click="$refs.fileInput.click()"
        >
          <i class="bx" :class="{ 'bx-loader': isUploadFile, 'bx-upload': !isUploadFile }"></i>
          Import file
        </b-button>
        <input
          type="file"
          ref="fileInput"
          accept=".xlsx"
          class="d-none"
          @change="handleFileChange"
        />
      </div>
    </div>
    <div class="p-10 card pt-15 b-t-1-869fb229">
      <div class="card-header m-b-10">
        <form class="box-search" @submit.prevent="">
          <div class="form-group">
            <input
              type="text"
              v-model.trim="search.keyword"
              class="form-control f12 hc-37"
              placeholder="Từ khóa"
              @keydown.enter.prevent="fetchData"
            />
          </div>

          <div class="form-group">
            <Select2
              v-model="search.moId"
              :options="moOptions"
              :settings="moSettings"
              placeholder="Tìm kiểm merchant owner"
              @change="onChangeMo"
            />
          </div>
          <div class="form-group">
            <Select2
              v-model="search.maId"
              :options="maOptions"
              :settings="maSettings"
              placeholder="Tìm kiếm merchant account"
              @change="onChangeMa"
            />
          </div>

          <div class="form-group">
            <Select2
              v-model="search.storeId"
              :options="storeOptions"
              :settings="storeSettings"
              placeholder="Tìm kiếm cửa hàng"
            />
          </div>
          <div class="form-group">
            <Select2
              v-model="search.businessRegionCode"
              :options="dataConfigRegion"
              @change="queryProvince($event)"
              placeholder="Vùng kinh doanh"
            />
          </div>
          <div class="form-group">
            <Select2
              v-model="search.businessProvinceCode"
              :options="dataProvince"
              :disabled="!search.businessRegionCode || search.businessRegionCode === '0'"
              placeholder="Tỉnh/Thành phố kinh doanh"
            />
          </div>
          <div class="form-group">
            <Select2
              v-model="search.regionCode"
              :options="dataConfigRegionMC"
              @change="queryMcProvince($event)"
              placeholder="Vùng merchant"
            />
          </div>
          <div class="form-group">
            <Select2
              v-model="search.provinceCode"
              :options="dataProvinceMC"
              placeholder="Tỉnh/Thành phố merchant"
              :disabled="!search.regionCode || search.regionCode === '0'"
              @change="getMcDistrict($event)"
            />
          </div>
          <div class="form-group">
            <Select2
              v-model="search.districtCode"
              :options="dataDistrict"
              placeholder="Quận/Huyện merchant"
              :disabled="!search.provinceCode || search.provinceCode === '0'"
            />
          </div>
          <div class="form-group">
            <Select2
              v-model="search.regionCodeStore"
              :options="dataConfigRegionMC"
              @change="queryMcProvince($event, 1)"
              placeholder="Vùng cửa hàng"
            />
          </div>
          <div class="form-group">
            <Select2
              v-model="search.provinceCodeStore"
              :options="dataProvinceMCStore"
              placeholder="Tỉnh/Thành phố cửa hàng"
              :disabled="!search.regionCodeStore || search.regionCodeStore === '0'"
              @change="getMcDistrictStore($event)"
            />
          </div>
          <div class="form-group">
            <Select2
              v-model="search.districtCodeStore"
              :options="dataDistrictStore"
              placeholder="Quận/Huyện cửa hàng"
              :disabled="!search.provinceCodeStore || search.provinceCodeStore === '0'"
            />
          </div>
          <div class="form-group">
            <Select2
              v-model="search.handlerMainRegionId"
              :options="dataConfigRegionMC"
              @change="queryMcProvince($event, 2)"
              placeholder="Vùng của người xử lý"
            />
          </div>
          <div class="form-group">
            <Select2
              v-model="search.handlerMainProvinceId"
              :options="dataProvinceMC2"
              placeholder="Tỉnh của người xử lý"
              :disabled="!search.handlerMainRegionId || search.handlerMainRegionId === '0'"
            />
            <!-- @change="getMcDistrict($event)" -->
          </div>

          <div class="form-group">
            <DateRangePicker
              class="w-100"
              :ranges="false"
              @update="transformDate()"
              v-model="dateRange"
              :locale-data="localeData"
            >
              <template v-slot:input="picker">
                <label
                  v-if="picker.startDate && picker.endDate"
                  style="min-width: 13.5em"
                  class="text-center font-size-12"
                >
                  {{ picker.startDate | formatDate }} -
                  {{ picker.endDate | formatDate }}
                </label>
                <label v-else style="min-width: 13.5em" class="font-size-12 time-placeholder">
                  Thời gian
                </label>
              </template>
            </DateRangePicker>
          </div>
          <div class="form-group">
            <DateRangePicker
              class="w-100"
              :ranges="false"
              @update="transformDate()"
              v-model="dateRangeProcessing"
              :locale-data="localeData"
            >
              <template v-slot:input="picker">
                <label
                  v-if="picker.startDate && picker.endDate"
                  style="min-width: 13.5em"
                  class="text-center font-size-12"
                >
                  {{ picker.startDate | formatDate }} -
                  {{ picker.endDate | formatDate }}
                </label>
                <label v-else style="min-width: 13.5em" class="font-size-12 time-placeholder">
                  Thời gian xử lý
                </label>
              </template>
            </DateRangePicker>
          </div>
          <div class="form-group">
            <DateRangePicker
              class="w-100"
              :ranges="false"
              @update="transformDate()"
              v-model="dateRangeEndIntendTime"
              :locale-data="localeData"
            >
              <template v-slot:input="picker">
                <label
                  v-if="picker.startDate && picker.endDate"
                  style="min-width: 13.5em"
                  class="text-center font-size-12"
                >
                  {{ picker.startDate | formatDate }} -
                  {{ picker.endDate | formatDate }}
                </label>
                <label v-else style="min-width: 13.5em" class="font-size-12 time-placeholder">
                  Thời gian XL dự kiến
                </label>
              </template>
            </DateRangePicker>
          </div>
          <div class="form-group">
            <Select2 v-model="search.saleId" :options="dataStaff" placeholder="Người xử lý">
            </Select2>
          </div>
          <div class="form-group">
            <Select2
              v-model="search.group"
              :options="Config.getSearch(optionsType)"
              @change="getCatCalendar"
              placeholder="Nhóm công việc"
            >
            </Select2>
          </div>
          <div class="form-group">
            <Select2
              v-model="search.name"
              :options="Config.getSearch(optionsPurpose)"
              placeholder="Tên công việc"
              :disabled="!search.group || search.group === '0'"
            >
            </Select2>
          </div>
          <div class="form-group">
            <Select2
              v-model="search.subCategoryCode"
              :settings="searchWork"
              placeholder="Tiểu mục CV"
            >
            </Select2>
          </div>
          <div class="form-group">
            <Select2
              v-model="search.status"
              :options="Config.getSearch(optionStatus)"
              placeholder="Trạng thái chăm sóc"
            >
            </Select2>
          </div>
          <div class="form-group">
            <Select2
              v-model="search.approvedStatus"
              :options="optionStatusApprove"
              placeholder="Trạng thái duyệt"
            >
            </Select2>
          </div>
          <div class="form-group">
            <Select2 v-model="search.result" :options="optionResult" placeholder="Kết quả">
            </Select2>
          </div>
          <div class="form-group">
            <Select2 v-model="search.applyFor" :options="dataApplyFor" placeholder="Đối tượng">
            </Select2>
          </div>

          <div class="form-group">
            <Select2
              v-model="search.methodCare"
              :options="listMethodCare"
              placeholder="Loại chăm sóc"
            >
            </Select2>
          </div>
          <div class="form-group">
            <Select2
              v-model="search.typePosm"
              :options="[
                { id: 0, text: 'Tất cả' },
                { id: 'POSM_1', text: 'POSM mẫu 1' },
                { id: 'POSM_2', text: 'POSM mẫu 2' },
                { id: 'POSM_1_2', text: 'POSM mẫu 1 và 2' },
              ]"
              placeholder="Loại POSM"
            >
            </Select2>
          </div>
          <div class="form-group form-group-action">
            <button
              @click="fetchData"
              class="pt-2 mr-2 btn btn-primary hc-37"
              data-toggle="tooltip"
              data-placement="top"
              title="Lọc"
            >
              <i class="bx bx-filter-alt"></i><span>&nbsp;</span>Lọc
            </button>
            <button
              @click="removeForm"
              type="button"
              class="pt-2 mr-2 btn btn-outline-light hc-37"
              data-toggle="tooltip"
              data-placement="top"
              title="Bỏ lọc"
            >
              <i class="bx bx-filter-alt"></i><span>&nbsp;</span>Bỏ lọc
            </button>
            <button type="button" class="pt-2 mr-2 btn btn-info hc-37" @click="addTask">
              Thêm
            </button>
          </div>
        </form>
      </div>
      <div class="card-body">
        <div class="tab-content" id="nav-tabContent">
          <div class="p-10">
            <!-- Tổng công việc:<strong class="text-primary">&nbsp;{{ pagination.total | formatNumberVN }}</strong> -->
            <TotalCount :totals="pagination.total" :data="totals" />
            <b-table
              :busy.sync="loading"
              head-variant="light"
              sticky-header
              hover
              responsive
              :items="dataTask"
              show-empty
              empty-text="Không có dữ liệu!"
              :fields="fieldsTable"
              selectable
              select-mode="single"
              :fixed="true"
              :bordered="true"
            >
              <template #table-busy>
                <div class="my-2 text-center">
                  <b-spinner class="align-middle"></b-spinner>
                </div>
              </template>
              <template #cell(index)="data">
                {{ getIndex(data.index) }}
              </template>
              <template #cell(task)="data">
                <p>{{ data.item.name ?? '' }}</p>
                <p class="text-primary">
                  {{ data.item.group ? joinArrayData(data.item.group, optionsType) : '' }}
                </p>
                <p>
                  <b class="text-muted">Tiểu mục CV:</b>
                  {{ data.item.subCategoryName ?? '' }}
                </p>
                <p>
                  <b class="text-muted">Hình thức:</b>
                  {{ data.item.methodCare }}
                </p>
              </template>
              <template #cell(time)="data">
                <div class="d-flex text-nowrap">
                  <div>
                    <b class="text-muted d-inline-block" style="width: 32px">Tạo: </b
                    ><span class="text-nowrap" v-if="data.item.createdDate">{{
                      data.item.createdDate | formatDate('HH:mm, DD/MM/YYYY')
                    }}</span
                    ><br />
                  </div>
                  <div class="ml-1 text-nowrap" style="color: #999">
                    ({{ showDateAgo(data.item.createdDate) }})
                  </div>
                </div>
                <div class="">
                  <div>
                    <b class="" style="width: 32px; color: #6c757d">Hoàn thành: </b
                    ><span class="text-nowrap" v-if="data.item.lastModifiedDate">{{
                      data.item.lastModifiedDate | formatDate('HH:mm, DD/MM/YYYY')
                    }}</span
                    ><br />
                  </div>
                  <div class="ml-1 text-nowrap" style="color: #999">
                    ({{ showDateAgo(data.item.lastModifiedDate) }})
                  </div>
                </div>
              </template>
              <template #cell(handler)="data">
                <div>
                  <b class="text-muted d-inline-block" style="width: 68px">Người tạo: </b>
                  <span v-if="data.item.createdInfo">{{
                    data.item.createdInfo.name ?? data.item.createdInfo.name
                  }}</span>
                  <br />
                </div>
                <div>
                  <b class="text-muted d-inline-block" style="width: 68px">Người xử lý: </b>
                  <span v-if="data.item.assignee">{{ data.item.assignee.name ?? '' }}</span>
                </div>
              </template>
              <template #cell(status)="{ item }">
                <!-- <div>
                  <span :class="`badge ${getStatusClass(data.item.status)}`">{{ getStatusName(data.item.status) }}</span>
                </div>
                <div v-if="data.item.result" class="mt-1">
                  ({{ getResultName(data.item.result) }})
                </div> -->
                <!-- <div v-if="item.status === EnumTaskStatus.FINISH">
                  <span class="badge" :class="item.result === EnumTaskResultStatus.FAILED ? 'badge-danger' : 'badge-success'">{{ getResultName(item.result) }}</span>
                </div> -->
                <div>
                  <span class="badge" :class="getStatusClass(item?.status)">{{
                    getStatusName(item?.status)
                  }}</span>
                </div>
              </template>
              <template #cell(approvedStatus)="{ item }">
                <div v-if="item?.approvedStatus">
                  <p>
                    <span :class="`badge ${getApproveClass(item?.approvedStatus)}`">{{
                      getApproveName(item?.approvedStatus)
                    }}</span>
                  </p>
                  <p v-if="item?.approvedStatus == 'REJECTED'">
                    Lý do: {{ item?.reasonReject || '' }}
                  </p>
                </div>
              </template>
              <template #cell(merchant)="data">
                <div
                  v-if="
                    data.item.applyFor == 'STORE' &&
                    data.item.storeInfo &&
                    Object.keys(data.item.storeInfo).length > 0
                  "
                >
                  <p>
                    <span class="text-muted">Cửa hàng:</span>
                    {{ data.item.storeInfo.name ?? '' }}
                  </p>
                  <div v-if="data.item.storeInfo.email">
                    <b-icon icon="envelope-fill"></b-icon>
                    <a :href="`mailto:${data.item.storeInfo.email}`">
                      {{ data.item.storeInfo.email }}</a
                    >
                  </div>
                  <div v-if="data.item.storeInfo.address">
                    <b-icon icon="geo-alt"></b-icon>
                    <strong
                      class="text-primary"
                      style="cursor: pointer"
                      @click="openInGoogleMaps(data.item.storeInfo.address)"
                      >{{ data.item.storeInfo.address }}</strong
                    >
                  </div>
                </div>
                <div
                  v-else-if="
                    data.item.applyFor == 'MO' &&
                    data.item.customerInfoRes &&
                    Object.keys(data.item.customerInfoRes).length > 0
                  "
                >
                  <p>
                    <span class="text-muted">MO: </span>
                    {{ data.item.customerInfoRes.merchantName ?? '' }}
                  </p>
                  <div v-if="data.item.customerInfoRes.email">
                    <b-icon icon="envelope-fill"></b-icon>
                    <a :href="`mailto:${data.item.customerInfoRes.email}`">{{
                      data.item.customerInfoRes.email
                    }}</a>
                  </div>
                  <div v-if="data.item.customerInfoRes.address">
                    <b-icon icon="geo-alt"></b-icon>
                    <strong
                      class="text-primary"
                      style="cursor: pointer"
                      @click="openInGoogleMaps(data.item.customerInfoRes.address)"
                      >{{ data.item.customerInfoRes.address }}</strong
                    >
                  </div>
                </div>
                <div
                  v-else-if="
                    data.item.applyFor == 'MA' &&
                    data.item.customerInfoRes &&
                    Object.keys(data.item.customerInfoRes).length > 0
                  "
                >
                  <p>
                    <span class="text-muted">MA: </span>
                    {{ data.item.customerInfoRes.merchantName ?? '' }}
                  </p>
                  <div v-if="data.item.customerInfoRes.email">
                    <b-icon icon="envelope-fill"></b-icon>
                    <a :href="`mailto:${data.item.customerInfoRes.email}`">{{
                      data.item.customerInfoRes.email
                    }}</a>
                  </div>
                  <div v-if="data.item.customerInfoRes.address">
                    <b-icon icon="geo-alt"></b-icon>
                    <strong
                      class="text-primary"
                      style="cursor: pointer"
                      @click="openInGoogleMaps(data.item.customerInfoRes.address)"
                      >{{ data.item.customerInfoRes.address }}</strong
                    >
                  </div>
                </div>

                <div
                  v-if="
                    data.item.applyFor == 'STORE' &&
                    data.item.customerInfoRes &&
                    Object.keys(data.item.customerInfoRes).length > 0
                  "
                >
                  <p>
                    <span class="text-muted">MA: </span>
                    {{ data.item.customerInfoRes.merchantName ?? '' }}
                  </p>
                  <div v-if="data.item.customerInfoRes.email">
                    <b-icon icon="envelope-fill"></b-icon>
                    <a :href="`mailto:${data.item.customerInfoRes.email}`">{{
                      data.item.customerInfoRes.email
                    }}</a>
                  </div>
                  <div v-if="data.item.customerInfoRes.address">
                    <b-icon icon="geo-alt"></b-icon>
                    <strong
                      class="text-primary"
                      style="cursor: pointer"
                      @click="openInGoogleMaps(data.item.customerInfoRes.address)"
                      >{{ data.item.customerInfoRes.address }}</strong
                    >
                  </div>
                </div>
              </template>
              <template #cell(province)="{ item }">
                <div class="text-center" v-if="item?.locationData?.provinceCodeTask">
                  {{ getCityName(item?.locationData?.provinceCodeTask) }}
                </div>
              </template>
              <template #cell(action)="{ item }">
                <div class="text-left m-b-5">
                  <b-link
                    :to="`/customer-support/task/${item.id}`"
                    target="_blank"
                    style="color: #0056f6"
                    size="sm"
                  >
                    <img
                      src="@/assets/img/circle-three-dots.svg"
                      alt="Circle with Three Dots"
                      style="width: 15px; height: 15px"
                    />
                    Chi tiết
                  </b-link>
                </div>
                <!-- <div class="text-left m-b-5" v-if="['PROCESSING', 'NEW'].includes(item.status)">
                  <b-link :to="`/customer-support/task/${item.id}/edit`" style="color: #0056F6;" size="sm">
                    <i class='bx bx-edit-alt' style="width: 15px; height: 15px;"></i> Cập nhật
                  </b-link>
                </div> -->
                <div class="text-left m-b-5" v-if="showEditBtn(item)">
                  <b-link
                    :to="`/customer-support/task/${item.id}/edit`"
                    style="color: #0056f6"
                    size="sm"
                  >
                    <i class="bx bx-edit-alt" style="width: 15px; height: 15px"></i>
                    Cập nhật
                  </b-link>
                </div>
                <div class="text-left m-b-5" v-if="showProcessBtn(item)">
                  <b-link
                    :to="`/customer-support/task/${item.id}/process`"
                    style="color: #0056f6"
                    size="sm"
                  >
                    <i class="bx bx-edit-alt" style="width: 15px; height: 15px"></i>
                    Xử lý
                  </b-link>
                </div>
                <div class="text-left m-b-5" v-if="showCancelBtn(item)">
                  <b-link style="color: #0056f6" size="sm" @click="handleConfirmCancel(item)">
                    <i class="bx bx-minus" style="width: 15px; height: 15px"></i>
                    Huỷ
                  </b-link>
                </div>
                <!-- <div class="text-left m-b-5" v-if="data.item.status == 'NEW' || data.item.status == 'PROCESSING'">
                  <b-link href="#" style="color: #0056F6;" size="sm" @click.prevent="showEditTask(data.item)">
                    <b-icon icon="arrow-repeat" style="width: 15px; height: 15px;"></b-icon> Cập nhật
                  </b-link>
                </div> -->
                <!-- <div class="text-left">
                  <b-link href="#" style="color: #0056F6;" size="sm" target="_blank">
                    <i class='bx bx-trash-alt' style="width: 15px; height: 15px;"></i> Huỷ
                  </b-link>
                </div> -->
              </template>
            </b-table>
          </div>
        </div>
      </div>
      <div class="d-flex justify-content-end pagination-bottom">
        <b-pagination
          v-model="search.page"
          @change="onChangePage"
          :total-rows="pagination.total"
          :per-page="search.limit"
          class="mr-2 fl-right"
        ></b-pagination>
      </div>
    </div>

    <PopupUpdateTask ref="popupUpdateTaskRef" @updateCalendar="fetchData" />
    <PopupShowInfoImport ref="popupShowInfoImportRef" @close="onClosePopupImport" />
    <PopupConfirmCancel ref="popupConfirmCancelRef" @change="fetchData" />
    <VueLoadingOverlay :active.sync="showLoading" :is-full-page="true"> </VueLoadingOverlay>
  </div>
</template>
<script>
  import { vi } from 'vuejs-datepicker/dist/locale'
  import { StaffService } from '@/services/staff.service'
  import { LocationService } from '@/services/location.service'
  import moment from 'moment'
  import { mapGetters } from 'vuex'
  import prepareQueryParamsMixin from '@/mixins/prepareQueryParamsMixin.js'
  import Config from '@/thirdParty/config'
  import mxItemAction from './mx-item-action.js'
  import {
    List,
    WorkGroupList,
    WorkTaskList,
    DownloadFileTemplate,
    UploadFileListTask,
  } from '@/services/customer-support/task'
  import PopupUpdateTask from './components/PopupUpdateTask.vue'
  import { List as ListMo } from '@/services/customer-support/merchant-owner'
  import { Search as ListMa } from '@/services/customer-support/account'
  import { List as ListStore } from '@/services/customer-support/store'
  import { CommonService } from '@/services/common.service'
  import {
    EnumTaskMethodCare,
    TaskMethodCare,
    TaskStatus,
    mapResultName,
    EnumTaskStatus,
    EnumTaskResultStatus,
  } from '@/constant/customerSupport'
  import { SearchByCode } from '@/services/customer-support/location'
  import PopupShowInfoImport from './components/PopupShowInfoImport.vue'
  import { showMess } from '@/config/utils'
  import FileDownload from 'js-file-download'
  import { getDateAgo } from '@/utils/util'
  import TotalCount from '@/components/cskh/Counts.vue'
  import PopupConfirmCancel from './components/PopupConfirmCancel'
  import { CalendarAfsService } from '@/services/calendar-afs.service'

  const fieldsTable = [
    { key: 'index', label: 'STT', class: 'text-center' },
    { key: 'merchant', label: 'Merchant/Cửa hàng' },
    { key: 'province', label: 'Tỉnh/Thành phố' },
    { key: 'task', label: 'Công việc', class: 'task_class' },
    {
      key: 'time',
      label: 'Thời gian',
      class: 'time_class',
      thStyle: 'min-width: 250px',
    },
    { key: 'handler', label: 'NV tạo/xử lý' },
    { key: 'status', label: 'Trạng thái', class: 'text-center' },
    {
      key: 'approvedStatus',
      label: 'Trạng thái duyệt',
      class: 'text-center',
    },
    {
      key: 'action',
      label: 'Thao tác',
      fixIndex: 999,
      class: 'text-left',
      thStyle: 'min-width: 88px',
    },
  ]

  const currentUser = JSON.parse(localStorage.getItem('userData'))

  export default {
    name: 'calendarAFS',
    components: {
      PopupUpdateTask,
      PopupShowInfoImport,
      TotalCount,
      PopupConfirmCancel,
    },
    mixins: [prepareQueryParamsMixin, mxItemAction],
    data() {
      return {
        Config,
        EnumTaskMethodCare,
        EnumTaskStatus,
        EnumTaskResultStatus,
        listMethodCare: [{ id: '0', text: 'Tất cả' }, ...TaskMethodCare],
        fieldsTable,
        // filterTable: fieldsTable,
        // userData: JSON.parse(localStorage.getItem('userData')),
        currentUser,
        search: {
          page: 1,
          limit: 20,
          keyword: '',
          saleId: '',
          group: '',
          name: '',
          status: '',
          moId: '',
          maId: '',
          storeId: '',
          businessRegionCode: '',
          businessProvinceCode: '',
          regionCode: '',
          provinceCode: '',
          districtCode: '',
          applyFor: '',
          methodCare: '',
          approvedStatus: '',
          result: '',
          handlerMainRegionId: '',
          handlerMainProvinceId: '',
          regionCodeStore: '',
          provinceCodeStore: '',
          districtCodeStore: '',
        },
        pagination: {
          total: 0,
          conditionsMap: '',
        },
        dataTask: [],
        statistical: {},
        localeData: Config.localeData,
        dateRange: {
          startDate: null,
          endDate: null,
        },
        dateRangeProcessing: {
          startDate: null,
          endDate: null,
        },
        dateRangeEndIntendTime: {
          startDate: null,
          endDate: null,
        },
        dataStaff: [],
        dataDistrictStore: [],

        dataConfigRegion: [],
        dataProvince: [],
        dataConfigRegionMC: [],
        dataProvinceMC: [],
        dataProvinceMC2: [],
        dataDistrict: [],
        dataApplyFor: [
          { id: 0, text: 'Tất cả' },
          { id: 'MA', text: 'Merchant Account' },
          { id: 'MO', text: 'Merchant Owner' },
          { id: 'STORE', text: 'Store' },
        ],
        cityList: [],

        optionsPurpose: [],
        update: {},
        // dateRangeProcessing: {
        //   startProcessingDate: null,
        //   endProcessingDate: null
        // },
        resonArr: [],
        purposesSelected: null,
        loading: true,
        showLoading: false,
        vi: vi,
        fileImage: [],
        dataUpdate: {},
        // optionStatus: [
        //   { id: 'NEW', text: 'Mới tạo' },
        //   { id: 'PROCESSING', text: 'Đang xử lý' },
        //   { id: 'FINISH', text: 'Hoàn thành' },
        //   { id: 'CANCELED', text: 'Đã hủy' },
        // ],
        optionStatusApprove: [
          { id: '0', text: 'Tất cả' },
          { id: 'APPROVED', text: 'Đã duyệt', bgColor: 'badge-info' },
          { id: 'WAIT_APPROVED', text: 'Chưa duyệt', bgColor: 'badge-success' },
          { id: 'REJECTED', text: 'Từ chối', bgColor: 'badge-danger' },
        ],
        optionResult: [
          { id: '0', text: 'Tất cả' },
          { id: 'SUCCESS', text: 'Thành công', bgColor: 'badge-success' },
          { id: 'FAILED', text: 'Thất bại', bgColor: 'badge-danger' },
          { id: 'OTHERS', text: 'Khác', bgColor: 'badge-info' },
        ],

        optionStatus: [{ id: '0', text: 'Tất cả' }, ...TaskStatus],
        optionColorStatus: {
          NEW: 'badge type-primary',
          PROCESSING: 'badge type-warning',
          FINISH: 'badge type-success',
          CANCELED: 'badge type-danger',
        },
        optionsType: [],

        moOptions: [],
        maOptions: [],
        storeOptions: [],

        isDownloadFile: false,
        isUploadFile: false,

        // totals: {
        //   canceledRecord: 0,
        //   finishRecord: 0,
        //   newRecord: 0,
        //   notCompletedRecord: 0,
        //   processingRecord: 0,
        // },
        totals: [
          {
            status: 'Huỷ',
            status_class: 'text-danger',
            count: 0,
          },
          {
            status: 'Hoàn thành',
            status_class: 'text-success',
            count: 0,
          },
          {
            status: 'Mới tạo',
            status_class: 'text-primary',
            count: 0,
          },
          {
            status: 'Không hoàn thành',
            status_class: 'text-info',
            count: 0,
          },
          {
            status: 'Đang xử lý',
            status_class: 'text-warning',
            count: 0,
          },
        ],

        tLoadMo: undefined,
        moSettings: {
          ajax: {
            delay: 500,
            transport: (params, success, failure) => {
              const txtSearch = params.data?.q?.trim() || ''
              if (!txtSearch) {
                return success({
                  results: [],
                })
              }

              // const queryString = txtSearch ? `{textSearch} LIKE '''${txtSearch}'''` : ''
              if (this.tLoadMo) {
                clearTimeout(this.tLoadMo)
              }
              this.tLoadMo = setTimeout(() => {
                ListMo({
                  // showFields: ["id", "ownerName", "email"],
                  limit: 10,
                  page: 1,
                  // queryString,
                  keyWord: txtSearch,
                  sort: {
                    direction: 'ASC',
                    properties: ['ownerName'],
                  },
                })
                  .then(res => {
                    success({
                      results:
                        res.data.list?.map(item => {
                          return {
                            id: item.id,
                            text: item.ownerName || item.email,
                          }
                        }) || [],
                    })
                  })
                  .catch(failure)
              }, 500)
            },
          },
        },

        tLoadMa: undefined,
        maSettings: {
          ajax: {
            delay: 500,
            transport: (params, success, failure) => {
              const txtSearch = params.data?.q?.trim() || ''
              if (!txtSearch) {
                return success({
                  results: [],
                })
              }

              const querys = [
                `{textSearch} LIKE '''${txtSearch}''' OR {address} LIKE '''${txtSearch}'''`,
              ]
              this.search.maId && querys.push(`{mcAccountId} == '''${this.search.maId}'''`)

              if (this.tLoadMa) {
                clearTimeout(this.tLoadMa)
              }
              this.tLoadMa = setTimeout(() => {
                ListMa({
                  showFields: ['id', 'accountName', 'email'],
                  limit: 10,
                  page: 1,
                  queryString: querys.join(' AND '),
                  sort: {
                    direction: 'ASC',
                    properties: ['accountName'],
                  },
                })
                  .then(res => {
                    success({
                      results: res.data.listData.map(item => {
                        return {
                          id: item.id,
                          text: item.accountName || item.email,
                        }
                      }),
                    })
                  })
                  .catch(failure)
              }, 500)
            },
          },
        },

        tLoadStore: undefined,
        storeSettings: {
          ajax: {
            delay: 500,
            transport: (params, success, failure) => {
              const txtSearch = params.data?.q?.trim() || ''
              if (!txtSearch) {
                return success({
                  results: [],
                })
              }

              const querys = [
                `({textSearch} LIKE '''${txtSearch}''' OR {address} LIKE '''${txtSearch}''')`,
              ]
              this.search.moId && querys.push(`{merchantOwnerId} == '''${this.search.moId}'''`)
              this.search.maId && querys.push(`{mcAccountId} == '''${this.search.maId}'''`)

              if (this.tLoadStore) {
                clearTimeout(this.tLoadStore)
              }
              this.tLoadMa = setTimeout(() => {
                ListStore({
                  showFields: ['id', 'accountName', 'email'],
                  limit: 10,
                  page: 1,
                  queryString: querys.join(' AND '),
                  sort: {
                    direction: 'ASC',
                    properties: ['accountName'],
                  },
                })
                  .then(res => {
                    success({
                      results: res.data.listData.map(item => {
                        return {
                          id: item.id,
                          text: item.accountName || item.email,
                        }
                      }),
                    })
                  })
                  .catch(failure)
              }, 500)
            },
          },
        },
        dataProvinceMCStore: [],
        searchWork: {
          ajax: {
            delay: 500,
            transport: (params, success, failure) => {
              const txtSearch = params.data?.q?.trim() || ''
              if (!txtSearch) {
                return success({
                  results: [],
                })
              }
              const keySearch = txtSearch ?? ''
              if (this.tLoadOwner) {
                clearTimeout(this.tLoadOwner)
              }
              this.tLoadOwner = setTimeout(() => {
                CalendarAfsService.getWorkSubsection({
                  name: keySearch,
                  isActive: true,
                  page: 1,
                  limit: 20,
                }) // AI
                  .then(res => {
                    success({
                      results:
                        res.data?.map(item => {
                          return {
                            id: item.code || '',
                            text: item.name || '',
                          }
                        }) || [],
                    })
                  })
                  .catch(failure)
              }, 500)
            },
          },
        },
      }
    },
    mounted() {
      this.getRegions()
      this.getMcRegions()
      this.getCityList()
      this.configSystem()
    },
    created() {
      StaffService.getStaffByIdSuperior({ userId: this.currentUser.userId })
        .then(
          s =>
            s.data?.map(s => ({
              id: s.userId,
              text: `${s.name} - ${s.userName}`,
            })) ?? []
        )
        .then(s => (this.dataStaff = s))
      this.search.keyword = this.$route.query.keyword ?? ''
      this.getOptionType()

      const queries = this.$router.currentRoute.query
      if (queries.moId && queries.moName) {
        this.moOptions = [
          {
            id: queries.moId,
            text: queries.moName,
          },
        ]
        this.search.moId = queries.moId
      }
      if (queries.maId && queries.maName) {
        this.maOptions = [
          {
            id: queries.maId,
            text: queries.maName,
          },
        ]
        this.search.maId = queries.maId
      }
      if (queries.storeId && queries.storeName) {
        this.storeOptions = [
          {
            id: queries.storeId,
            text: queries.storeName,
          },
        ]
        this.search.storeId = queries.storeId
      }

      // this.listMethodCare.unshift({ id: '0', text: 'Tất cả' });

      this.fetchData()
    },
    watch: {},
    computed: {
      ...mapGetters({
        dataPermission: 'role/dataPermission',
      }),
      joinArrayData() {
        return (item, options) => {
          const mapData = options.find(e => e.id === item)
          return mapData ? mapData.text : ''
        }
      },
      // optionStatusApprove
      getApproveName() {
        return status => {
          const map = this.optionStatusApprove?.reduce((acc, cur) => {
            acc[cur.id] = cur.text
            return acc
          }, {})
          return map[status] || status
        }
      },
      getApproveClass() {
        return status => {
          const map = this.optionStatusApprove.reduce((acc, cur) => {
            acc[cur.id] = cur.bgColor
            return acc
          }, {})
          return map[status] || 'badge-info'
        }
      },
      getColor() {
        return (code, option) => {
          if (!code) return code
          return option[code] ? option[code] : code
        }
      },
      getStatusName() {
        return status => {
          const objStatus = this.optionStatus.find(s => s.id === status)
          return objStatus ? objStatus.text : status
        }
      },
      getStatusClass() {
        return status => {
          const objStatus = this.optionStatus.find(s => s.id === status)
          return objStatus?.bgColor ? objStatus.bgColor : 'badge-primary'
        }
      },
      getResultName() {
        return result => {
          return mapResultName[result] || result
        }
      },
      getCityName() {
        return city => {
          const objCity = this.cityList.find(e => e.id === city)
          return objCity ? objCity.text : city
        }
      },
      showEditBtn() {
        return item => {
          return (
            // this.dataPermission.includes('CNPS_CSS_TASK_UPDATE') && // có quyền cập nhật
            ([EnumTaskStatus.NEW, EnumTaskStatus.PROCESSING].includes(item?.status) && // trạng thái là NEW || PROCESSING (Mới tạo, Đang xử lý)
              item?.saleId === this.currentUser?.userId) || // là người xử lý
            ([EnumTaskStatus.NEW].includes(item?.status) && // trạng thái là NEW (Mới tạo)
              (item.createdBy === this.currentUser?.userId || // người tạo
                this.dataStaff.some(item => item.id === this.currentUser?.userId))) // người quản lý của người xử lý
          )
        }
      },
      showProcessBtn() {
        return item => {
          return (
            [EnumTaskStatus.NEW, EnumTaskStatus.PROCESSING].includes(item?.status) &&
            item?.methodCare === EnumTaskMethodCare.ONLINE &&
            item?.saleId === this.currentUser?.userId
          )
        }
      },
      showCancelBtn() {
        return item => {
          return (
            ([EnumTaskStatus.NEW, EnumTaskStatus.PROCESSING].includes(item?.status) &&
              item?.saleId === this.currentUser?.userId) ||
            ([EnumTaskStatus.NEW].includes(item?.status) &&
              item?.createdBy === this.currentUser?.userId)
          )
        }
      },
      showImportBtn() {
        return this.dataPermission.includes('CNPS_CSS_IMPORT_FILE')
      },
      showDateAgo() {
        return date => {
          return getDateAgo(date)
        }
      },
    },
    methods: {
      // define ngày trên lịch
      transformDate() {
        this.search.fromDate = moment(this.dateRange.startDate)
          .startOf('day')
          .add(7, 'hours')
          .valueOf()
        this.search.toDate = moment(this.dateRange.endDate).endOf('day').add(7, 'hours').valueOf()
      },
      // Bỏ lọc
      async removeForm() {
        this.search = {
          page: 1,
          limit: 20,
          keyword: '',
          saleId: '',
          group: '',
          name: '',
          status: '',
          moId: '',
          maId: '',
          storeId: '',
          businessRegionCode: '',
          businessProvinceCode: '',
          regionCode: '',
          provinceCode: '',
          districtCode: '',
          applyFor: '',
          typePosm: '',
        }
        this.dateRange = {
          startDate: null,
          endDate: null,
        }
        this.dateRangeProcessing = {
          startDate: null,
          endDate: null,
        }
        this.dateRangeEndIntendTime = {
          startDate: null,
          endDate: null,
        }
        this.pagination = {
          total: 0,
        }

        await this.fetchData()
      },
      async buildQuery() {
        const conditions = []
        const conditionsMap = {}

        const textSearch = this.search.keyword?.trim()
        textSearch &&
          conditions.push(
            `({customerInfoRes.merchantName} LIKE '''${textSearch}''' OR {customerInfoRes.mobile} LIKE '''${textSearch}''' OR {customerInfoRes.email} LIKE '''${textSearch}''' OR {storeInfo.name} LIKE '''${textSearch}''' OR {storeInfo.mobile} LIKE '''${textSearch}''' OR {storeInfo.email} LIKE '''${textSearch}''')`
          )

        this.search.approvedStatus &&
          this.search.approvedStatus !== '0' &&
          conditions.push(`{approvedStatus} == '''${this.search.approvedStatus}'''`)

        this.search.subCategoryCode &&
          this.search.subCategoryCode !== '0' &&
          conditions.push(`{subCategoryCode} == '''${this.search.subCategoryCode}'''`)

        this.search.result &&
          this.search.result !== '0' &&
          conditions.push(`{result} == '''${this.search.result}'''`)

        this.search.businessRegionCode &&
          this.search.businessRegionCode !== '0' &&
          (conditionsMap.businessRegionCode = this.search.businessRegionCode)
        this.search.businessProvinceCode &&
          this.search.businessProvinceCode !== '0' &&
          (conditionsMap.businessProvinceCode = this.search.businessProvinceCode)

        //
        this.search.handlerMainRegionId &&
          this.search.handlerMainRegionId !== '0' &&
          (conditionsMap.handlerMainRegionId = this.dataConfigRegionMC.find(
            item => item.id === this.search.handlerMainRegionId
          ).idForProvice)

        this.search.handlerMainProvinceId &&
          this.search.handlerMainProvinceId !== '0' &&
          (conditionsMap.handlerMainProvinceId = this.dataProvinceMC2.find(
            item => item.id === this.search.handlerMainProvinceId
          ).newId)
        //

        this.search.regionCode &&
          this.search.regionCode !== '0' &&
          conditions.push(`{locationData.regionCodeTask} == '''${this.search.regionCode}'''`)
        this.search.provinceCode &&
          this.search.provinceCode !== '0' &&
          conditions.push(`{locationData.provinceCodeTask} == '''${this.search.provinceCode}'''`)
        this.search.districtCode &&
          this.search.districtCode !== '0' &&
          conditions.push(`{locationData.districtCodeTask} == '''${this.search.districtCode}'''`)

        /// store
        this.search.regionCodeStore &&
          this.search.regionCodeStore !== '0' &&
          conditions.push(`{regionCodeStore} == '''${this.search.regionCodeStore}'''`)
        this.search.provinceCodeStore &&
          this.search.provinceCodeStore !== '0' &&
          conditions.push(`{provinceCodeStore} == '''${this.search.provinceCodeStore}'''`)
        this.search.districtCodeStore &&
          this.search.districtCodeStore !== '0' &&
          conditions.push(`{districtCodeStore} == '''${this.search.districtCodeStore}'''`)

        this.dateRange.startDate &&
          this.dateRange.endDate &&
          conditions.push(
            `{created_date} range [#${moment(this.dateRange.startDate).startOf('day').add(7, 'hours').toISOString()}#, #${moment(this.dateRange.endDate).endOf('day').add(7, 'hours').toISOString()}#]`
          )
        this.dateRangeProcessing.startDate &&
          this.dateRangeProcessing.endDate &&
          conditions.push(
            `{endProcessingTime} range [#${moment(this.dateRangeProcessing.startDate).startOf('day').add(7, 'hours').toISOString()}#, #${moment(this.dateRangeProcessing.endDate).endOf('day').add(7, 'hours').toISOString()}#]`
          )

        this.dateRangeEndIntendTime.startDate &&
          this.dateRangeEndIntendTime.endDate &&
          conditions.push(
            `{endIntendTime} range [#${moment(this.dateRangeEndIntendTime.startDate).startOf('day').add(7, 'hours').toISOString()}#, #${moment(this.dateRangeEndIntendTime.endDate).endOf('day').add(7, 'hours').toISOString()}#]`
          )

        this.search.moId &&
          this.search.moId !== '' &&
          conditions.push(`{merchantOwnerId} == '''${this.search.moId}'''`)
        this.search.maId &&
          this.search.maId !== '' &&
          conditions.push(`{customerId} == '''${this.search.maId}'''`)
        this.search.storeId &&
          this.search.storeId !== '' &&
          conditions.push(`{storeId} == '''${this.search.storeId}'''`)

        this.search.saleId &&
          this.search.saleId !== '0' &&
          conditions.push(`{assignee.userId} == '''${this.search.saleId}'''`)
        this.search.group &&
          this.search.group !== '0' &&
          conditions.push(`{group} == '''${this.search.group}'''`)
        this.search.name &&
          this.search.name !== '0' &&
          conditions.push(`{purposes} INCLUDE '''${this.search.name}'''`)
        // conditions.push(
        //   `{name} == '''${this.joinArrayData(this.search.name, this.optionsPurpose)}'''`
        // )
        this.search.status &&
          this.search.status !== '0' &&
          conditions.push(`{status} == '''${this.search.status}'''`)

        this.search.typePosm &&
          this.search.typePosm !== '0' &&
          conditions.push(`{typePosm} == '''${this.search.typePosm}'''`)

        this.search.applyFor &&
          this.search.applyFor !== '0' &&
          conditions.push(`{applyFor} == '''${this.search.applyFor}'''`)
        this.search.methodCare &&
          this.search.methodCare !== '0' &&
          conditions.push(`{methodCare} == '''${this.search.methodCare}'''`)

        this.pagination.queryString = conditions.join(' AND ')
        if (conditionsMap) {
          this.pagination.conditionsMap = conditionsMap
        }
      },

      // Dữ liệu bảng
      async fetchData() {
        try {
          this.loading = true
          this.buildQuery()
          const params = {
            limit: this.search.limit,
            page: this.search.page,
            typePurpose: 'NOTICE_CAMPAIGN',
            queryString: this.pagination.queryString,
            ...this.pagination.conditionsMap,
          }

          const res = await List(params)
          if (res.result) {
            this.dataTask = res.data.taskList ?? []
            this.pagination.total = res.data.total ?? 0
            this.totals[0].count = res.data.canceledRecord
            this.totals[1].count = res.data.finishRecord
            this.totals[2].count = res.data.newRecord
            this.totals[3].count = res.data.notCompletedRecord
            this.totals[4].count = res.data.processingRecord
          } else {
            showMess(this, 'Thông báo', res.message, 'danger', 'b-toaster-top-right', 5 * 60 * 60)
          }
        } catch (e) {
          showMess(
            this,
            'Thông báo',
            e.response?.message || e.message,
            'danger',
            'b-toaster-top-right',
            5 * 60 * 60
          )
        } finally {
          this.loading = false
        }
      },

      openInGoogleMaps(address) {
        const url = `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(address)}`
        window.open(url, '_blank')
      },
      onChangePage(page) {
        this.search.page = page
        this.fetchData()
      },
      async getOptionType() {
        try {
          const response = await WorkGroupList({
            status: 'APPLYING',
            page: 1,
            size: 1000,
          })
          if (response.code && response.code == 1000) {
            this.optionsType = response.data
              ? response.data.reduce((arr, current) => {
                  if (current.groupCode && current.groupName && current.id) {
                    arr.push({
                      id: current.groupCode,
                      text: current.groupName,
                      mapId: current.id,
                    })
                  }
                  return arr
                }, [])
              : []
          } else {
            this.showFailMx(response.message)
          }
        } catch (e) {
          showMess(
            this,
            'Thông báo',
            e.response?.message || e.message,
            'danger',
            'b-toaster-top-right',
            5 * 60 * 60
          )
        }
      },
      async getCatCalendar() {
        try {
          this.optionsPurpose = []
          this.search.name = ''
          const wkGroupId = this.optionsType.find(item => item.id == this.search.group)
          if (!wkGroupId) return

          const response = await WorkTaskList({
            status: 'APPLYING',
            page: 1,
            size: 1000,
            wkGroupId: wkGroupId ? wkGroupId.mapId : '',
          })
          if (response.code && response.code == 1000) {
            this.optionsPurpose = response.data
              ? response.data.reduce((arr, current) => {
                  if (current.taskCode && current.taskName) {
                    arr.push({ id: current.taskCode, text: current.taskName })
                  }
                  return arr
                }, [])
              : []
          } else {
            this.showFailMx(response.message)
          }
        } catch (e) {
          showMess(
            this,
            'Thông báo',
            e.response?.message || e.message,
            'danger',
            'b-toaster-top-right',
            5 * 60 * 60
          )
        }
      },
      addTask() {
        // window.open('/customer-support/task/new','_blank')
        this.$router.push('/customer-support/task/new')
      },
      showEditTask(item) {
        this.$refs.popupUpdateTaskRef?.show(item.taskWkcldASId)
      },
      onChangeMo() {
        this.search.maId = ''
        this.search.storeId = ''
      },

      onChangeMa() {
        this.search.storeId = ''
      },
      // lấy vùng
      async getRegions() {
        const data = await StaffService.getRegions()
        if (data.data.length > 0) {
          this.dataConfigRegion = data.data.map(e => {
            return {
              id: e.id,
              text: e.name,
            }
          })
          this.dataConfigRegion.unshift({ id: '0', text: 'Tất cả' })
        }
      },
      // lấy tỉnh, tp
      async queryProvince(e) {
        try {
          this.search.businessProvinceCode = ''
          this.dataProvince = []
          const data = await StaffService.getProvinceRegion({ regionId: [e] })
          if (data.data.length > 0) {
            this.dataProvince = data.data.map(e => {
              return {
                id: e.id,
                text: e.name,
              }
            })
            this.dataProvince.unshift({ id: '0', text: 'Tất cả' })
          }
        } catch (e) {
          showMess(
            this,
            'Thông báo',
            e.response?.message || e.message,
            'danger',
            'b-toaster-top-right',
            5 * 60 * 60
          )
        }
      },
      // lấy vùng mc
      async getMcRegions() {
        const data = await StaffService.getRegions()
        if (data.data.length > 0) {
          this.dataConfigRegionMC = data.data.map(e => {
            return {
              id: e.code,
              text: e.name,
              idForProvice: e.id,
            }
          })
          this.dataConfigRegionMC.unshift({ id: '0', text: 'Tất cả' })
        }
      },
      // lấy tỉnh, tp mc
      async queryMcProvince(e, type = 0) {
        if (type === 0) {
          try {
            this.search.provinceCode = ''
            this.search.districtCode = ''
            this.dataDistrict = []
            this.dataProvinceMC = []
            const data = await StaffService.getProvinceRegion({
              regionId: [this.dataConfigRegionMC.find(data => data.id == e).idForProvice],
            })
            if (data.data.length > 0) {
              this.dataProvinceMC = data.data.map(e => {
                return {
                  id: e.code,
                  text: e.name,
                  newId: e.id,
                }
              })
              this.dataProvinceMC.unshift({ id: 0, text: 'Tất cả' })
            }
          } catch (e) {
            showMess(
              this,
              'Thông báo',
              e.response?.message || e.message,
              'danger',
              'b-toaster-top-right',
              5 * 60 * 60
            )
          }
        } else if (type === 1) {
          try {
            this.search.provinceCodeStore = ''
            this.search.districtCodeStore = ''
            this.dataDistrictStore = []
            this.dataProvinceMCStore = []
            const data = await StaffService.getProvinceRegion({
              regionId: [this.dataConfigRegionMC.find(data => data.id == e).idForProvice],
            })
            if (data.data.length > 0) {
              this.dataProvinceMCStore = data.data.map(e => {
                return {
                  id: e.code,
                  text: e.name,
                  newId: e.id,
                }
              })
              this.dataProvinceMCStore.unshift({ id: 0, text: 'Tất cả' })
            }
          } catch (e) {
            showMess(
              this,
              'Thông báo',
              e.response?.message || e.message,
              'danger',
              'b-toaster-top-right',
              5 * 60 * 60
            )
          }
        } else {
          try {
            this.search.handlerMainProvinceId = ''
            this.dataProvinceMC2 = []
            const data = await StaffService.getProvinceRegion({
              regionId: [this.dataConfigRegionMC.find(data => data.id == e).idForProvice],
            })
            if (data.data.length > 0) {
              this.dataProvinceMC2 = data.data.map(e => {
                return {
                  id: e.code,
                  text: e.name,
                  newId: e.id,
                }
              })
              this.dataProvinceMC2.unshift({ id: 0, text: 'Tất cả' })
            }
          } catch (e) {
            showMess(
              this,
              'Thông báo',
              e.response?.message || e.message,
              'danger',
              'b-toaster-top-right',
              5 * 60 * 60
            )
          }
        }
      },

      async getMcDistrict(event) {
        this.search.districtCode = ''
        const data = await SearchByCode({ code: event })
        if (data.data.length > 0) {
          this.dataDistrict = data.data
            .sort((a, b) => a.locationCode.localeCompare(b.locationCode))
            .map(e => {
              return {
                id: e.locationCode,
                text: e.localName,
              }
            })
        }
        this.dataDistrict.unshift({ id: '0', text: 'Tất cả' })
      },
      async getMcDistrictStore(event) {
        this.search.districtCodeStore = ''
        const data = await SearchByCode({ code: event })
        if (data.data.length > 0) {
          this.dataDistrictStore = data.data
            .sort((a, b) => a.locationCode.localeCompare(b.locationCode))
            .map(e => {
              return {
                id: e.locationCode,
                text: e.localName,
              }
            })
        }
        this.dataDistrictStore.unshift({ id: '0', text: 'Tất cả' })
      },

      configSystem() {
        return CommonService.getConfigSystem().then(data => {
          if (data.success) {
            this.optionStatus = data.data.taskCskhStatus.map(e => {
              return {
                ...e,
                id: e.code,
                text: e.name,
              }
            })
          }
        })
      },

      async getCityList() {
        const mapLocations = await LocationService.getCityList()
        if (mapLocations.success && mapLocations.data) {
          this.cityList = mapLocations.data.map(e => {
            return {
              id: e.code,
              text: e.name,
            }
          })
        }
      },
      async downloadTemplateFile() {
        try {
          this.isDownloadFile = true
          const res = await DownloadFileTemplate()
          // const blob = new Blob([res], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
          // const href = window.URL.createObjectURL(blob);
          // const link = document.createElement('a');
          // link.href = href;
          // // link.download = 'template-cskh-task.xlsx';
          // link.setAttribute('download', 'template-cskh-task.xlsx')
          // document.body.appendChild(link);
          // link.click();
          // document.body.removeChild(link);
          // URL.revokeObjectURL(href);

          FileDownload(res, 'template-cskh-task.xlsx')
        } catch (e) {
          showMess(
            this,
            'Thông báo',
            e.response?.message || e.message,
            'danger',
            'b-toaster-top-right',
            5 * 60 * 60
          )
        } finally {
          this.isDownloadFile = false
        }
      },
      async handleFileChange(event) {
        const file = event.target.files[0]
        if (file) {
          try {
            this.isUploadFile = true
            const formData = new FormData()
            formData.append('file', file)
            const res = await UploadFileListTask(formData, ({ loaded, total }) => {
              console.log(((loaded / total) * 100).toFixed(2).replace('.00', ''))
            })

            if (res.code === 1000) {
              this.$refs.popupShowInfoImportRef?.show(res.data)
            } else {
              showMess(this, 'Thông báo', res.message, 'danger', 'b-toaster-top-right', 5 * 60 * 60)
            }
          } catch (e) {
            showMess(
              this,
              'Thông báo',
              e.response?.data?.message || e.response?.message || e.message,
              'danger',
              'b-toaster-top-right',
              5 * 60 * 60
            )
          } finally {
            this.isUploadFile = false
            this.$refs.fileInput.value = null
          }
        }
      },
      onClosePopupImport() {
        this.fetchData()
      },
      handleConfirmCancel(item) {
        this.$refs.popupConfirmCancelRef?.show(item)
      },
    },
  }
</script>
<style scoped>
  .wrapper-cancel {
    margin-top: 30px;
    font-size: 24px;
    text-align: center;
    padding: 0 15px;
  }

  .NEW {
    color: #fff;
    background-color: #6c757d !important;
  }

  .time_class {
    width: 250px;
    min-width: 250px;
    /* max-width: 200px; */
  }

  .creator_class {
    min-width: 150px;
    max-width: 220px;
  }

  .task_class {
    min-width: 150px;
    max-width: 200px;
  }

  .type-warning {
    color: #fff;
    background-color: #ffc107;
  }

  .type-success {
    color: #fff;
    background-color: #1a9e3f;
  }

  .type-danger {
    color: #fff;
    background-color: #dc3545;
  }

  .type-primary {
    color: #fff;
    background-color: #007bff;
  }
</style>
